import { useDispatch, useSelector } from 'react-redux';
import React, { useState } from 'react';

import * as actions from '../../../redux/actions';
import { getSiteMutationError } from '../../../redux/selectors';

import { Footer } from './SiteDelete.stc';
import Button from '../../Button';
import Modal from '../../Modal';
import Input from '../../Input';
import Label from '../../Label';
import Alert from '../../Alert';

function SiteDelete({ onClose, site }) {
    const [input, setInput] = useState('');
    const dispatch = useDispatch();
    const errorMessage = useSelector(getSiteMutationError);

    const handleDelete = (e) => {
        e.preventDefault();
        if (input && input.toLowerCase() === 'delete') {
            dispatch(actions.deleteSite(site.id));
            // TODO: handle deletion failure
            onClose();
        }
    };
    return (
        <Modal
            size="sm"
            onClose={onClose}
            header={
                <div>
                    <strong>DELETE WEBSITE</strong> ({site.url || site.id})
                </div>
            }
            footer={
                <Footer>
                    <Button onClick={onClose} type="link">
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} type="danger">
                        Delete Site
                    </Button>
                </Footer>
            }
        >
            <Alert type="warning">
                <strong>Warning</strong> Site config chagnes will affect your
                website URL accessibility
            </Alert>

            <form style={{ marginTop: 25 }}>
                <Label htmlFor="confirmDelete">Type "DELETE" to confirm:</Label>
                <Input
                    value={input}
                    id="confirmDelete"
                    onChange={(e) => setInput(e.target.value)}
                />
            </form>
            {errorMessage && <p>{errorMessage}</p>}

            <p>
                Your site will be permanently deleted. If you need any help
                contact support@dorik.co
            </p>
        </Modal>
    );
}

export default SiteDelete;
